import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handlePhoneChange, handleNameChange, handlePostalChange, handleZipChange, handleMessageChange, handleSubmit } from '../../utils/formHandlers';
import { fetchCountryFromIP } from '../../utils/fetchCountryFromIP';
import { FaArrowRight } from 'react-icons/fa';

function FormTwoColumn({ cityData }) {
    const navigate = useNavigate();
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [zip, setZip] = useState('');
    const [message, setMessage] = useState('');
    const [country, setCountry] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        fetchCountryFromIP().then(ipData => {
            if (ipData) {
                setCountry(ipData.country_name);
            }
        });
    }, []);

    const formSubmitHandler = (event) => {
        event.preventDefault();

        // Perform validation
        if (!validateForm()) {
            return; // Stop form submission if validation fails
        }

        const formState = { name, phone, postalCode, zip, message };
        
        handleSubmit(formState, cityData, 
            () => {
                // Handle success, e.g., clear form, show success message
                navigate('/thankyou'); // Redirect to the thank you page
            }, 
            (error) => {
                // Handle error, e.g., show error message
                console.error("Error adding lead: ", error);
            }
        );
    };

    const validateForm = () => {
        const newErrors = {};
    
        // Mapping state values to field names
        const fieldValues = {
            name, phone, message
        };
    
        // List all fields that need to be validated
        const requiredFields = [
            'name', 'phone', 'message'
        ];
    
        // Check if each field is filled out
        requiredFields.forEach(field => {
            if (!fieldValues[field]) {
                newErrors[field] = 'This field is required';
            }
        });
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <section className="contact-one">
            <div className="container">
                <div className="row">
                    <div className="col-md-8">
                        <div className="contact-one__left">
                            <div className="section-title text-left">
                                <span className="section-title__tagline">Free Estimate</span>
                                <h2 className="section-title__title">Complete the form to get your free quote in minutes:</h2>
                            </div>
                            {/* <div className="contact-one__phone">
                                <div className="contact-one__phone-img">
                                    <img src={phoneImage} alt="" />
                                </div>
                                <div className="contact-one__phone-content">
                                    <p>Call or Text us:</p>
                                    <h4>
                                        <Link to="tel:416-555-1234">416-555-1234</Link>
                                    </h4>
                                </div>
                            </div>
                            <p className="contact-one__time">Monday - Saturday <br /> 9:00 am - 6:00 pm</p> */}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="contact-one__right">
                            <form 
                                onSubmit={formSubmitHandler} 
                                className="contact-one__form contact-form-validated"
                                noValidate="noValidate"
                            >
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="contact-one__input-box">
                                        <input type="text" name="location_id" onChange={(e) => handleZipChange(setZip, e)} value={cityData.locationId} autoComplete="off" hidden  />
                                            <input 
                                                type="text" 
                                                placeholder="Name:" 
                                                name="name" 
                                                autoComplete="name"
                                                className={errors.name ? 'input-error' : ''}
                                                value={name}
                                                onChange={(e) => handleNameChange(setName, e)}
                                                maxLength={20}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="contact-one__input-box">
                                            <input 
                                                type="text" 
                                                placeholder="Phone:" 
                                                name="phone" 
                                                autoComplete="tel"
                                                className={errors.name ? 'input-error' : ''}
                                                value={phone}
                                                onChange={(e) => handlePhoneChange(setPhone, e)}
                                                maxLength={12}
                                                required
                                            />
                                        </div>
                                    </div>
                                    {!cityData.locationId && (
                                    <div className="col-md-2">
                                        <div className="contact-one__input-box">
                                        {country === 'Canada' && (
                                            <input 
                                                    type="text" 
                                                    placeholder="Postal code:" 
                                                    name="zip" 
                                                    autoComplete="zip"
                                                    value={postalCode.toUpperCase()}
                                                    onChange={(e) => handlePostalChange(setPostalCode, e)}
                                                    maxLength={6}
                                                    required
                                                /> 
                                            )}
                                            {country === 'Canada' && (
                                                <input 
                                                    type="text" 
                                                    placeholder="Zip code:" 
                                                    name="zip" 
                                                    autoComplete="zip"
                                                    value={zip}
                                                    onChange={(e) => handleZipChange(setZip, e)}
                                                    maxLength={5}
                                                    required
                                                />
                                            )}
                                        </div>
                                    </div>
                                    )}
                                    <div className="col-md-4">
                                        <div className="contact-one__input-box text-message-box">
                                            <textarea 
                                                name="message" 
                                                placeholder="What do you want us to remove?" 
                                                value={message} 
                                                className={errors.name ? 'input-error' : 'form-control'}
                                                autoComplete="off"
                                                onChange={(e) => handleMessageChange(setMessage, e)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="">
                                                <button 
                                                    type="submit" 
                                                    className="thm-btn contact-one__btn"
                                                >
                                                    Go! <FaArrowRight />
                                                </button>
                                            </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default FormTwoColumn;